import { Settings as defaults } from "./settings.default";
import { AiFillInstagram, AiFillFacebook } from "react-icons/ai";
import merge from "lodash.merge";
import { PaymentTypeEnum } from "@application/types/PaymentType.enum";
import { LANGUAGE } from "@config/lang";
import { SEARCH_TYPES } from "@config/const/enums";

export const Settings = merge(defaults, {
  endpoint: "https://admin.aurora-rks.com/",
  languages: [LANGUAGE.SQ, LANGUAGE.EN],
  encodeUrl: false,
  hashRouter: true,
  defaultLanguage: "mk",
  links: {
    top: ["phone", "email", "b2b", "lang"],
    menu: [],
  },
  menuLinks: [],
  googleAnalyticsTrackingId: null,
  contact: {
    map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d9020.973074814272!2d21.12015151472437!3d42.64752346318967!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x13549f988cd8565f%3A0xdc60d99ed23ef44a!2sAurora%20Travel%20Agency!5e0!3m2!1sen!2smk!4v1738748449866!5m2!1sen!2smk",
  },
  social: [
    {
      name: "Facebook",
      Icon: AiFillFacebook,
      url: "https://facebook.com/Auroratravel.ks/",
    },
    {
      name: "Instagram",
      Icon: AiFillInstagram,
      url: "https://www.instagram.com/aurora.travel.agency/",
    },
  ],
  search: {
    order: [SEARCH_TYPES.hotel, SEARCH_TYPES.charter],
    charter: {
      displayDepartures: true,
      extraDays: 1,
    },
    hotel: {
      minBookingStartDays: 1,
      displayDepartures: false,
    },
  },
  booking: {
    show_extend_hotel_night: false,
    passengers: {
      require_passport_no: true,
    },
    payments: [
      {
        type: PaymentTypeEnum.Cash,
        label: "payments.cash",
        public: true,
        agent: false,
      },
      // {
      //   type: PaymentTypeEnum.CreditCard,
      //   label: "payments.cc",
      //   public: true,
      //   agent: false,
      // },
      {
        type: PaymentTypeEnum.Invoice,
        label: "payments.inv",
        public: false,
        agent: true,
      },
    ],
  },
  iframe: {
    allowBooking: false,
  },
  b2b: {
    bookings: {
      show_document_download: true,
    },
  },
});
